module.exports = __webpack_public_path__ + "static/media/Postales-04.28a03f70.png";